import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SkeletonAnimation } from '../../skeleton-loader.types';

@Component({
  selector: 'cm-skeleton-full-layout',
  standalone: true,
  imports: [],
  templateUrl: './skeleton-full-layout.component.html',
  styleUrl: './skeleton-full-layout.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkeletonFullLayoutComponent {
  public readonly animation = input<SkeletonAnimation>('shimmer');
}
